"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.HotArticleEntity = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../../../types");
var constants_1 = require("../../../constants");
var fields_1 = require("../../../fields");
var slices_1 = require("../../../slices");
var page_factory_1 = require("./page-factory");
exports.HotArticleEntity = page_factory_1.pageFactory(types_1.PageType.HOT_ARTICLE, function (prismicDoc, normalizedPage, logger) {
    var _a;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return utils_1.compact(__assign(__assign({}, normalizedPage), { localization: logger.required(constants_1.toLocalization((_b = prismicDoc.data) === null || _b === void 0 ? void 0 : _b.localization, logger)), filters: utils_1.compact((_a = {},
            _a[types_1.Filter.Category] = logger.required(constants_1.toCategory((_c = prismicDoc === null || prismicDoc === void 0 ? void 0 : prismicDoc.data) === null || _c === void 0 ? void 0 : _c.category, logger)),
            _a[types_1.Filter.Localization] = constants_1.toLocalizationFilter((_d = prismicDoc === null || prismicDoc === void 0 ? void 0 : prismicDoc.data) === null || _d === void 0 ? void 0 : _d.localization, logger),
            _a[types_1.Filter.Thematic] = logger.required(constants_1.toThematic((_e = prismicDoc === null || prismicDoc === void 0 ? void 0 : prismicDoc.data) === null || _e === void 0 ? void 0 : _e.thematic, logger)),
            _a)), publicationDate: fields_1.toTimestamp((_f = prismicDoc === null || prismicDoc === void 0 ? void 0 : prismicDoc.data) === null || _f === void 0 ? void 0 : _f.publication_date), onHome: fields_1.toBoolean((_g = prismicDoc === null || prismicDoc === void 0 ? void 0 : prismicDoc.data) === null || _g === void 0 ? void 0 : _g.onHome), body: slices_1.toSlices((_h = prismicDoc.data) === null || _h === void 0 ? void 0 : _h.body_slices, logger), card: {
            title: fields_1.toText((_j = prismicDoc.data) === null || _j === void 0 ? void 0 : _j.card_title),
            image: fields_1.toImage((_k = prismicDoc.data) === null || _k === void 0 ? void 0 : _k.card_image, logger)
        } }));
});
//# sourceMappingURL=hot-article.js.map